<template>
	<Modal :width="850" :title="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.title')"
		   :close-on-click-outside="false"
		   @close="closeNoticeModal">
		<template v-slot:body>
			<div class="modal-content flex flex_column" style="overflow: hidden">
				<div v-if="showManualStartHint" class="text_left light_bg_color" style="margin-bottom: 30px">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.bundled.hint')"></span>
				</div>
				<div class="margin_top_l text_left">
					<span v-html="$t('seller.upload.saveAndSubmit.confirmation.automaticStartOfSale.multi.text')"></span>
				</div>
				<AgItem class="margin_top_l" style="overflow: auto"
						:rowData="confirmationData"
						:columnDefs="columnDefs"
						height-type="matchRows"
				/>
			</div>

			<div class="margin_r margin_top flex_end w_100">
				<md-button class="md-blank margin_r" @click="closeNoticeModal">{{ $t("common.button.cancel") }}</md-button>
				<md-button @click="confirm" class="md-primary">{{ $t("common.continue") }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {enumDef} from "@/common/enumDefs";
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import {asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	components: {
		AgItem,
		Modal
	},
	props: {
		confirmationData: Array,
	},
	data() {
		return {
			columnDefs: []
		};
	},
	created() {
		this.columnDefs = [
			{
				headerName: this.$t("common.invoiceNumber"),
				field: "invoiceNumber",
				minWidth: 150
			},
			{
				headerName: this.$t("common.invoiceAmount"),
				headerClass: "align-right",
				field: "invoiceAmount",
				cellStyle: { "justify-content": "flex-end" },
				valueFormatter: asMoneyAmount({ currencyField: "currency" }),
				minWidth: 150
			},
			{
				headerName: this.$t("seller.upload.price.instantPayout"),
				headerClass: "align-right",
				field: "priceCheck.instantPayoutInclRetention",
				cellStyle: { "justify-content": "flex-end" },
				valueFormatter: asMoneyAmount({ currencyField: "currency" }),
				minWidth: 150
			},
			// When some receivables use retention then show an additional retention payout column. For receivables without retention the payout is shown as "n/a"
			...(this.showRetentionColumn
				? [{
					headerName: this.$t("common.retention"),
					headerClass: "align-right",
					field: "priceCheck.retentionPayout",
					cellStyle: { "justify-content": "flex-end" },
					valueFormatter: asMoneyAmount({ currencyField: "currency", showZeroAsNotAvailable: true }),
					minWidth: 150
				}] : []
			)
		];
	},
	computed: {
		enumDef() {
			return enumDef;
		},
		showManualStartHint() {
			return this.confirmationData.some(data => !this.doesHaveAutomaticStart(data));
		},
		showRetentionColumn() {
			return this.confirmationData.some(data => this.doesConfirmationUseRetention(data));
		},
	},
	methods: {
		doesHaveAutomaticStart(data) {
			return data.priceCheck.automaticallyStartSale;
		},
		doesConfirmationUseRetention(data) {
			return data.retentionCheck.sellWithRetention;
		},
		closeNoticeModal() {
			this.$emit("close");
		},
		confirm() {
			this.$emit("confirm", this.confirmationData);
		},
	}
};
</script>